import React from 'react';

const ReChartRadialBar = ({ label, data }) => {
    const sorted = [...(data || [])].sort((a, b) => b.value - a.value);

    return (
        <div className='df fdc'>
            <p className='fb cs fs12 mb1' style={{ textTransform: 'uppercase', letterSpacing: '0.1em' }}>{label}</p>
            <table style={{ width: '100%', borderCollapse: 'separate', borderSpacing: '0 4px' }}>
                <thead>
                    <tr>
                        <td className='fl cw fs11' style={{ padding: '6px 8px', opacity: 0.5 }}>Nom</td>
                        <td className='fl cw fs11 tac' style={{ padding: '6px 8px', opacity: 0.5, width: 70 }}>%</td>
                    </tr>
                </thead>
                <tbody>
                    {sorted.map((item, i) => (
                        <tr key={i} style={{ background: i === 0 ? 'rgba(151, 84, 227, 0.15)' : 'rgba(255,255,255,0.03)', borderRadius: 6 }}>
                            <td className='fm cw fs12' style={{ padding: '8px 10px', borderRadius: '6px 0 0 6px' }}>{item.name}</td>
                            <td className='fb cw fs13 tac' style={{ padding: '8px 10px', borderRadius: '0 6px 6px 0' }}>{item.value}%</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default ReChartRadialBar;
